
export function createDirector(payload = {}) {
  return {
    type: 'REQUEST_DIRECTOR_CREATE',
    payload
  };
}
